import React from 'react';
import * as R from 'ramda';
import { useSelector } from 'react-redux';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature compensation-group
import { CompensationsWithActions } from './components/compensations';
import { makeSelectDriverGuid, makeSelectVendorGuid } from './selectors';
//////////////////////////////////////////////////

const Details = (props) => {
  const driverGuid = useSelector(makeSelectDriverGuid());
  const vendorGuid = useSelector(makeSelectVendorGuid());

  const isFleetProfile = R.isNotNil(R.or(driverGuid, vendorGuid));

  const guid = R.path(['parentProps', GC.FIELD_GUID], props);
  const maxWidth = G.ifElse(isFleetProfile, 'calc(100vw - 132px)', 1498);
  const isReadOnlyMode = R.path(['callbackData', 'isReadOnlyMode'], props);

  return <CompensationsWithActions guid={guid} maxWidth={maxWidth} isReadOnlyMode={isReadOnlyMode} />;
};

const tableSettings = {
  minHeight: 340,
  cellFontSize: 13,
  titleFontSize: 14,
  titleRowHeight: 45,
  tableRowHeight: 40,
  allowEditBtn: true,
  expandableItems: true,
  checkBoxCellWidth: 70,
  searchableTitles: true,
  allowSelectItems: false,
  expandedDetailsComponent: Details,
  checkBoxCellJustifyContent: 'unset',
};

const columnSettings = {
  [GC.FIELD_NAME]: {
    width: 200,
    searchable: true,
    name: 'titles:name',
  },
  [GC.FIELD_ACTIVE]: {
    width: 150,
    type: 'boolean',
    searchable: true,
    name: 'titles:active',
  },
  [GC.FIELD_CREATED_BY]: {
    width: 200,
    searchable: true,
    name: 'titles:created-by',
  },
  [GC.FIELD_CREATED_DATE]: {
    width: 200,
    type: 'date',
    searchable: true,
    name: 'titles:created-date',
  },
  [GC.FIELD_LAST_MODIFIED_BY]: {
    width: 200,
    searchable: true,
    name: 'titles:last-modified-by',
  },
  [GC.FIELD_LAST_MODIFIED_DATE]: {
    type: 'date',
    searchable: true,
    name: 'titles:last-modified-date',
  },
};

const FILTER_PARAMS = R.compose(
  R.values,
  R.mapObjIndexed(({ name, type = 'string' }, value) => ({
    type,
    value,
    name: G.getWindowLocale(name),
  })),
)(columnSettings);

export {
  FILTER_PARAMS,
  tableSettings,
  columnSettings,
};
